export const REPORTED_STATUS_NONE = 'NONE'
export const REPORTED_STATUS_REPORTED = 'REPORTED'
export const REPORTED_STATUS_FAILED = 'FAILED'